import { Disclosure } from '@headlessui/react'
import { HiChevronDown } from 'react-icons/hi'
import { classNames } from 'src/helpers/utilities'

interface MobileFilterMenuProps {
  name: string
  children: JSX.Element[] | JSX.Element
}

export default function MobileFilterMenu({ name, children }: MobileFilterMenuProps) {
  return (
    <Disclosure as="div" key={name} className="border-t border-gray-200 px-4 py-6">
      {({ open }) => (
        <>
          <h3 className="-mx-2 -my-3 flow-root">
            <Disclosure.Button className="px-2 py-3 bg-white w-full flex items-center justify-between text-sm text-gray-400 outline-brand-500">
              <span className="font-medium text-gray-900">{name}</span>
              <span className="ml-6 flex items-center">
                <HiChevronDown
                  className={classNames(open ? '-rotate-180' : 'rotate-0', 'h-5 w-5 transform')}
                  aria-hidden="true"
                />
              </span>
            </Disclosure.Button>
          </h3>
          <Disclosure.Panel className="pt-6">{children}</Disclosure.Panel>
        </>
      )}
    </Disclosure>
  )
}
